// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGBreezeSingleStar = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#breezeSingleStar__clip0_7668_25951)",
    children: [/*#__PURE__*/_jsx("path", {
      fillOpacity: 0.01,
      d: "M0 0h32v32H0z"
    }), /*#__PURE__*/_jsx("mask", {
      id: "breezeSingleStar__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#breezeSingleStar__clip1_7668_25951)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M16 .011c.631 0 1.143.512 1.143 1.143 0 7.575 6.14 13.714 13.714 13.714.631 0 1.143.512 1.143 1.143s-.512 1.143-1.143 1.143c-7.574 0-13.714 6.14-13.714 13.714 0 .631-.512 1.143-1.143 1.143s-1.143-.512-1.143-1.143c0-7.574-6.14-13.714-13.714-13.714-.631 0-1.143-.512-1.143-1.143 0-.63.512-1.143 1.143-1.143 7.574 0 13.714-6.14 13.714-13.714 0-.631.512-1.143 1.143-1.143z"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#breezeSingleStar__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "breezeSingleStar__clip0_7668_25951",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "breezeSingleStar__clip1_7668_25951",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGBreezeSingleStar.displayName = 'SVGBreezeSingleStar';
export default SVGBreezeSingleStar;